import { DEFAULT_LANGUAGE, Language, isLanguage } from "@repo/common"

// The language is saved on the account (User.language). This copy only covers
// the screens shown before the user is known, like the login page.
const LANGUAGE_STORAGE_KEY = "alfred-language"

export const readDeviceLanguage = (): Language => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
    return stored && isLanguage(stored) ? stored : DEFAULT_LANGUAGE
  } catch {
    return DEFAULT_LANGUAGE
  }
}

export const storeDeviceLanguage = (language: Language): void => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  } catch (error) {
    console.error("Failed to store language preference:", error)
  }
}

// The language the UI renders in, sent to the API with every request so part
// names come back translated. Set by TranslationProvider while rendering,
// like DateUtils, so it is right before any child query fires.
let uiLanguage: Language = readDeviceLanguage()

export const setUiLanguage = (language: Language): void => {
  uiLanguage = language
}

export const getUiLanguage = (): Language => uiLanguage
